import { getDiscountPercentage } from '@skin-seoul/service';

import { useProductCard } from '../ProductCardContext';

export const DiscountBadge = () => {
  const { originalPrice, salePrice } = useProductCard();
  const discountPercentage = getDiscountPercentage(originalPrice, salePrice);

  if (discountPercentage <= 0) return null;

  return (
    <div className="absolute top-0 left-0 z-[3] bg-primary-400 px-[6px] py-[2px] rounded-tl-[8px] rounded-br-[8px] flex items-center justify-center">
      <span className="text-generic-0 text-label-medium font-medium whitespace-nowrap">{discountPercentage}% off</span>
    </div>
  );
};
